export class HTTPError extends Error {}
